/**
 * Helps to create DeliveryDetailsBusinessModelExtended and get parts of address
 * It creates DeliveryDetailsBusinessModelExtended, because AddressId and FormattedAddress are not part of OnlineOrderDeliveryDetailsBusinessModel
 */
export class DeliveryAddressModel {
    constructor(private _address: OLO.DTO.AddressSugestionDto, private _extraInstructions: Nullable<string> = null, private _unit: Nullable<string> = null) {
        if (!_address || typeof _address === 'string') return;
    }

    public getDeliveryDetailsBusinessModel(): APICommon.DeliveryDetailsBusinessModelExtended {
        return {
            AddressId: this.getAddressId(),
            Building: this.getBuildingNo(),
            City: this.getCity(),
            ExtraInstructions: this.getExtraInstructions(),
            FormattedAddress: this.getFormattedAddress(),
            Latitude: this.getLatitude(),
            Longitude: this.getLongitude(),
            PostCode: this.getPostCode(),
            State: this.getState(),
            Street: this.getStreet(),
            Unit: this.getAptNo(),
            Country: this.getCountry(),
        };
    }

    public getDeliveryDetailsBusinessModelExtended(pickupDate: string, nextTick: number): APICommon.DeliveryDetailsBusinessModelExtended {
        return {
            ...this.getDeliveryDetailsBusinessModel(),
            DesiredDeliveryTime: pickupDate,
            EstimatedDeliveryTime: nextTick,
        };
    }

    public getAddressId(): string {
        return this._address?.AddressId;
    }

    public getFormattedAddress(): string {
        return this._address?.FormattedAddress;
    }

    public getStreet(): string {
        return this._address?.StructuredAddressDto?.Street;
    }

    public getState(): string {
        return this._address?.StructuredAddressDto?.State;
    }

    public getBuildingNo(): string {
        return this._address?.StructuredAddressDto?.BuildingNumber;
    }

    public getAptNo(): string {
        return this._address?.StructuredAddressDto?.Unit || this._unit || '';
    }

    public getCity(): string {
        return this._address?.StructuredAddressDto?.City;
    }

    public getPostCode(): string {
        return this._address?.StructuredAddressDto?.Postcode;
    }

    public getLatitude(): number {
        return this._address?.StructuredAddressDto?.Geolocation.Latitude;
    }

    public getLongitude(): number {
        return this._address?.StructuredAddressDto?.Geolocation.Longitude;
    }

    public getCountry(): string {
        return this._address?.StructuredAddressDto?.Country;
    }

    public getExtraInstructions(): string {
        return this._extraInstructions || '';
    }
}
